import { ref, computed } from 'vue';
import { SearchAPI } from '@/shared/legacy/api/search';
import { useServerSideAutocomplete } from '../../autocomplete-next/search-engine/use-server-side-autocomplete';
import { collapseContacts, useHiddenContactsCache } from './model';

function useSelectedContacts() {
  const selectedContacts = ref([]);
  const isContactSelected = (email) => selectedContacts.value.includes(email);

  const updateSelectedContacts = (list) => {
    selectedContacts.value = list;
  };

  return {
    isContactSelected,
    updateSelectedContacts
  };
}

export function useEmailAutocomplete({ coworkers, options: { includeResources, isSearch } }) {
  const { isContactHidden } = useHiddenContactsCache();
  const { isContactSelected, updateSelectedContacts } = useSelectedContacts();

  const { search: searchContacts, result: resultContacts, isLoading: isSearchLoading, isLoaded: isSearchLoaded } = useServerSideAutocomplete({
    sources: [
      {
        getRequest: (query) => SearchAPI.searchContacts({
          q: query,
          page: 1,
          count: 100,
          ...(!includeResources ? { exclude: 'resources' } : {})
        }),
        itemsMapper: collapseContacts
      }
    ],
    options: {
      includeBasePath: true
    }
  });

  const result = computed((previous) => {
    /**
     * Необходимо, чтобы во время загрузки запроса при переключении режима ввода не показывалась кнопка "Добавить"
     * Подробнее https://huntflow.atlassian.net/browse/PROD-6237
     */
    if (isSearchLoading.value || (isSearch.value && !isSearchLoaded.value)) {
      return previous ?? [];
    }

    if (isSearch.value) {
      return resultContacts.value ?? [];
    }

    return [{ items: coworkers }];
  });

  const filteredResult = computed(() => {
    const isContactVisible = (contact) => {
      return !isContactSelected(contact.email) && !isContactHidden(contact);
    };

    return result.value.map((group) => ({
      ...group,
      items: group.items.filter(isContactVisible)
    }));
  });

  const search = (query) => {
    if (isSearch.value) {
      searchContacts(query);
    }
  };

  return {
    result: filteredResult,
    search,
    setExcludeEmailsList: (list) => {
      updateSelectedContacts(list);
    }
  };
}
